export const TERMS_OR_SERVICE_URL = `${process.env.REACT_APP_MAIN_SITE}/terms-of-service`;
export const PRIVACY_POLICY_URL = `${process.env.REACT_APP_MAIN_SITE}/privacy-policy`;
export const FAQ_URL = `${process.env.REACT_APP_MAIN_SITE}/faq`;

export const errorMessages = {
  notFound: 'Page Not Found',
  general: 'Oops! Something went wrong',
};

export const emptyText = {
  shows: 'No shows',
  noResults: 'No results',
  emptyChat: 'Chat is empty',
};

export const enum AlertType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Default = 'default',
}

export const SIDE_MENU_WIDTH = 256;
export const HEADER_HEIGHT = 112;
export const MOBILE_HEADER_HEIGHT = 72;
export const BOTTOM_MENU_HEIGHT = 80;
// aspect ratio 2:1 for show image picker
export const SHOW_CARD_WIDTH = 320;
export const SHOW_CARD_HEIGHT = 160;

export const RECORDED_SHOW_PLAYER_HEIGHT = 120;

export const PARTICIPANT_NAME_HEIGHT = 32;
export const PARTICIPANT_SKEW_OFFSET = 0.3;

export const DATE_FORMAT = 'dd-MMM-yyyy';
export const BIRTHDAY_FORMAT = 'yyyy-MM-dd';
export const SCHEDULED_SHOW_DATE_FORMAT = 'do MMM';
export const TIME_FORMAT = 'HH:mm';
export const FULL_DATE_TIME_FORMAT = 'HH:mm dd MMMM yyyy ';
export const VIDEO_FILE_EXTENSION = '.m3u8';

export const SHOWS_PER_PAGE = 15;
export const CHANNELS_PER_PAGE = 30;
export const LISTENERS_PER_PAGE = 15;
export const USERS_PER_PAGE = 30;
export const CHAT_MESSAGES_PER_PAGE = 50;
export const GIFS_QUERY_PER_PAGE = 20;

export const SKEW_ANGLE = 10;
export const MOBILE_SKEW_ANGLE = 4;

export const MIN_VISIBLE_SCORE = 70;

export const CURRENCY = '£';
